import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import styled from 'styled-components'
import BackgroundImage from 'gatsby-background-image'

import * as bgourStyle from "./bgour.module.css"
import { Container, Row, Col } from "react-bootstrap"

const BackgroundSection = ({ className }) => {
  const data = useStaticQuery(
    graphql`
      query {
        desktop: file(relativePath: { eq: "bgourprduct.png" }) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  )

  // Set ImageData.
  const imageData = data.desktop.childImageSharp.fluid

  return (
    <BackgroundImage
      Tag="section"
      className={className}
      fluid={imageData}
      backgroundColor={`#040e18`}
    >
    <Container fluid="xl" className={bgourStyle.home}>
        <Row>
          <Col>
            <h3 className={bgourStyle.header}>สินค้าของเรา</h3>
            <p className={bgourStyle.pstyles}>ด้วยความสามารถในการผลิตสินค้าที่ตรงตามความต้องการของลูกค้า ทำให้ TPP มีความหลากหลายของสินค้า</p>
          </Col>
        </Row>
      </Container>
    </BackgroundImage>
  )
}

const StyledBackgroundSection = styled(BackgroundSection)`
  width: 100%;
  background-position: top left;
  background-repeat: repeat-y;
  background-size: cover;
`

export default StyledBackgroundSection